import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { ContactForm } from '../ContactForm/ContactForm';
import { useLanguage } from '../../context/LanguageContext';
import { FiPhone } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { fadeInUp } from '../Screens/PublicContact/PublicContact';

export default function ContactSection() {
  const { t, isRTL } = useLanguage();
  return (
    <section className="relative  mt-12 sm:mt-16 lg:mt-56">
      <div className="relative">
        
        
        <div className="py-12 sm:py-16 px-5  bg-gradient-to-r from-secondary to-primary">
            <div className='max-w-4xl mx-auto'>
                <h1 className='text-center text-2xl font-roboto font-bold text-white md:text-6xl'>{t('contact.getInTouch')}</h1>
                <p className='text-center text-sm font-roboto font-semibold text-white md:text-xl py-5'>{t('contact.description')}</p>
   <motion.a
                        href="tel:01039456426"
                        className="flex items-center gap-3 bg-primary border border-white/20 rounded-xl px-5 py-2 mb-4 text-white hover:bg-white hover:text-primary transition-colors no-underline  "
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                        custom={0.4}
                    >
                        <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center shrink-0">
                            <FiPhone className="text-white text-base" />
                        </div>
                        <div>
                            <p className="text-[10px] md:text-xs mb-0.5">{t('contact.callUs')}</p>
                            <p className="  font-medium text-base m-0 text-left">01039456426</p>
                        </div>
                    </motion.a>
          <ContactForm/>
            </div>
        </div>
      </div>
    </section>
  );
}